import { TopicDetailModule } from '@/modules/horizon/topics/topic-detail/TopicDetailModule';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  id: z.coerce.string(),
});

const topicDetailSearchSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().default(20),
  search: z.string().optional(),
  statusTab: z.string().default('ACTIVE'),
  templateCategoryId: z.string().optional(),
  // Event sheet params
  sheet: z.enum(['create', 'edit', 'view']).optional(),
  eventId: z.string().optional(),
  duplicateFromId: z.string().optional(),
  groupDetailId: z.string().optional(),
  // Event action dialog params
  action: z.enum(['pause', 'expire', 'void']).optional(),
  actionId: z.string().optional(),
  groupBulk: z.enum(['1']).optional(),
  settleId: z.string().optional(),
  changeOutcomeId: z.string().optional(),
  finalizeSettleId: z.string().optional(),
  voidPendingId: z.string().optional(),
  resumeId: z.string().optional(),
  reverseSettleId: z.string().optional(),
  deleteId: z.string().optional(),
  reconId: z.string().optional(),
  // Topic action dialog params (matching list screen param names)
  liveBadge: z.string().optional(),
  pause: z.string().optional(),
  resume: z.string().optional(),
  expire: z.string().optional(),
  topicSheet: z.enum(['create', 'edit']).optional(),
});

export const Route = createFileRoute('/dashboard/horizon/topics/$id')({
  params: {
    parse: params => paramsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  validateSearch: topicDetailSearchSchema,
  component: TopicDetailPage,
});

function TopicDetailPage() {
  return <TopicDetailModule />;
}
